import { render, staticRenderFns } from "./shippingCompany.vue?vue&type=template&id=326c86b8&scoped=true&"
import script from "./shippingCompany.vue?vue&type=script&lang=js&"
export * from "./shippingCompany.vue?vue&type=script&lang=js&"
import style0 from "./shippingCompany.vue?vue&type=style&index=0&id=326c86b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326c86b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('326c86b8')) {
      api.createRecord('326c86b8', component.options)
    } else {
      api.reload('326c86b8', component.options)
    }
    module.hot.accept("./shippingCompany.vue?vue&type=template&id=326c86b8&scoped=true&", function () {
      api.rerender('326c86b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/shippingCompany.vue"
export default component.exports